module.exports = __webpack_public_path__ + "static/akwarium-3-91a25ebb89623ed4972ea8f51ae0c64c.jpg";